import { render } from "./DocEditProjectPopup.vue?vue&type=template&id=3b573953&scoped=true"
import script from "./DocEditProjectPopup.js?vue&type=script&lang=js"
export * from "./DocEditProjectPopup.js?vue&type=script&lang=js"

import "./DocEditProjectPopup.vue?vue&type=style&index=0&id=3b573953&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b573953"]])

export default __exports__